import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Image,
  SafeAreaView,
  StatusBar,
} from "react-native";
import React from "react";
import { Entypo } from "@expo/vector-icons";
import logo from "../img/logo.png";
import discord from "../assets/discord.png";
import instagram from "../assets/instagram.png";
import youtube from "../assets/youtube.png";
import linkedin from "../assets/linkedin.png";
import tiktok from "../assets/tiktok.png";
import twitter from "../assets/twitter.png";
import telegram from "../assets/telegram.png";
import whatsapp from "../assets/whatsapp.png";
import facebook from "../assets/facebook.png";
import pinterest from "../assets/pinterest.png";

const About = (props) => {
  return (
    <SafeAreaView style={styles.aboutContainer}>
      <StatusBar
        barStyle="light-content"
        hidden={false}
        backgroundColor="#192655"
        translucent={false}
        networkActivityIndicatorVisible={true}
        animated={true}
      />
      <View style={styles.header}>
        <TouchableOpacity onPress={() => props.navigation.goBack()}>
          <Entypo name="chevron-left" color="#fff" size={25} />
        </TouchableOpacity>
      </View>
      {/* <View style={{flexDirection: 'row'}}> */}
      <View>
        <Text style={styles.mainHeader}>BOSAD</Text>
        <Image style={styles.imgStyle} source={logo} />
      </View>

      <View style={styles.aboutLayout}>
        <Text style={styles.aboutSubHeader}> About Us </Text>
        <Text style={[styles.paraStyle, styles.aboutPara]}>
          We are BOSAD Research team including orthopedic surgeons and public
          health experts from different institution who aspire to see safe,
          affordable and accessible musculoskeletal care for all specially for
          the vulnerable group like Pediatric patients and who lived in rural
          areas in Ethiopia .
        </Text>
        <Text style={[styles.paraStyle, styles.aboutPara]}>
          Prepared by Drs. Mengistu Gebreyohanes and Ephrem Gebrehana
          representing BOSAD Project team.
        </Text>
      </View>

      <Text style={styles.mainHeader1}> Follow us on Social Network </Text>

      <View style={styles.menuContainer}>
        <TouchableOpacity
          style={styles.buttonStyle}
          onPress={() => Linking.openURL("https://t.me/BOSADEthiopia")}
        >
          <Image style={styles.iconStyle} source={telegram} />
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.buttonStyle}
          onPress={() =>
            Linking.openURL("https://linkedin.com/in/bosadethiopia")
          }
        >
          <Image style={styles.iconStyle} source={linkedin} />
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.buttonStyle}
          onPress={() => Linking.openURL("https://twitter.com/BOSADEthiopia")}
        >
          <Image style={styles.iconStyle} source={twitter} />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.buttonStyle}
          onPress={() =>
            Linking.openURL("https://www.instagram.com/bosadethiopia/")
          }
        >
          <Image style={styles.iconStyle} source={instagram} />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.buttonStyle}
          onPress={() =>
            Linking.openURL(
              "https://www.facebook.com/profile.php?id=61555217004486"
            )
          }
        >
          <Image style={styles.iconStyle} source={facebook} />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.buttonStyle}
          onPress={() =>
            Linking.openURL("https://www.tiktok.com/@bosadethiopia")
          }
        >
          <Image style={styles.iconStyle} source={tiktok} />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.buttonStyle}
          onPress={() =>
            Linking.openURL("https://www.pinterest.com/BOSADEthiopia")
          }
        >
          <Image style={styles.iconStyle} source={pinterest} />
        </TouchableOpacity>
      </View>
      <View>
        <Text style={[styles.aboutPara,styles.bottom]}>BOSAD Application V1.0</Text>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  aboutContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#192655",
  },

  imgStyle: {
    width: 140,
    height: 140,
    borderRadius: 10,
    backgroundColor: "#fff",
  },
  mainHeader: {
    fontSize: 50,
    color: "#fff",
    textTransform: "uppercase",
    fontWeight: "500",
    // marginTop: 10,
    marginBottom: 10,
  },
  mainHeader1: {
    fontSize: 20,
    color: "#fff",
    textTransform: "uppercase",
    fontWeight: "500",
    // marginTop: 30,
    marginBottom: 10,
  },
  header: {
    flexDirection: "row",
    // alignItems: "center",
    // justifyContent: "space-between",
    width: "100%",
    paddingHorizontal: 20,
    // paddingTop: 20,
    marginTop: 30,
  },
  paraStyle: {
    fontSize: 15,
    color: "#7d7d7d",
    paddingBottom: 30,
  },
  aboutLayout: {
    backgroundColor: "#4c5dab",
    paddingHorizontal: 30,
    marginVertical: 30,
  },
  aboutSubHeader: {
    fontSize: 18,
    color: "#fff",
    textTransform: "uppercase",
    fontWeight: "500",
    marginVertical: 15,
    alignSelf: "center",
  },
  aboutPara: {
    color: "#fff",
  },
  menuContainer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-evenly",
  },

  iconStyle: {
    width: "100%",
    height: 50,
    aspectRatio: 1,
  },
  bottom:{
    marginBottom:40
  }
});

export default About;
